import Name from "./Name";

const Country = { Name };

export default Country;
